import "./ErrorComponent.scss";
import { Link } from "react-router-dom";

const ErrorComponent = () => {
  return (
    <div className="error">
      <h1>404 Error :(</h1>
      <h2>The page you are trying to access does not exist.</h2>
      <Link to="/">Click Here to Return Home</Link>
    </div>
  );
};

export default ErrorComponent;
